import { mapExchange } from "urql";

/**
 * クライアント専用の追加 context を URQL Operation に付与します。
 * サーバー側と同じキー（authToken / logoutRedirectPathname）を統一的に設定します。
 */
export const createClientContextExchange = (token?: string) =>
  mapExchange({
    onOperation(operation) {
      const logoutRedirectPathname =
        typeof window === "undefined"
          ? undefined
          : `${window.location.pathname}${window.location.search ?? ""}`;

      return {
        ...operation,
        context: {
          ...operation.context,
          authToken: token ?? null,
          ...(logoutRedirectPathname ? { logoutRedirectPathname } : {}),
        },
      };
    },
  });
